"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringifyFeatureContext = void 0;
var stringifyFeatureContext = function (featureContext) { return JSON.stringify({
    contextualParameters: Array.from(featureContext.contextualParameters.entries()),
    attributeName: featureContext.attributeName,
}); };
exports.stringifyFeatureContext = stringifyFeatureContext;
